/**
 * Resolves a floor-plan asset against the app's own base path.
 *
 * The importer stores the backdrop as a bare filename, and an SVG <image>
 * with a relative href resolves against the PAGE url, not the app's base. So
 * `hall-plan.jpg` found the file at /swapmeet/ and 404'd at /, which is the
 * bare domain — the most likely thing for somebody to type. The backdrop then
 * vanished with no error anywhere a vendor could see it.
 *
 * Each app passes its own base (Vite's `import.meta.env.BASE_URL`, i.e.
 * "/swapmeet/" or "/admin/"), so the same stored filename resolves correctly
 * in both, from any page url.
 */
export function assetHref(href: string, base: string): string {
  // Already absolute, or a data/blob URI — leave it alone.
  if (/^([a-z]+:)?\/\//i.test(href) || href.startsWith('data:') || href.startsWith('/')) {
    return href;
  }
  // Use only the filename: a stored path prefix would double up on the base.
  const file = href.split('/').pop() ?? href;
  return `${base.endsWith('/') ? base : `${base}/`}${file}`;
}
